export const codigosCiaps = [
  { nm: null, nome: 'ABORTO ESPONTÂNEO', codigo: 'W82', id_grupo: 'ABORTO' },
  { nm: null, nome: 'ABORTO PROVOCADO', codigo: 'W83', id_grupo: 'ABORTO' },
  { nm: null, nome: 'ASMA', codigo: 'R96', id_grupo: 'ASMA' },
  {
    nm: null,
    nome: 'ISQUEMIA/ ACIDENTE CEREBRAL TRANSITÓRIA(O)',
    codigo: 'K89',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'TROMBOSE/ACIDENTE VASCULAR CEREBRAL',
    codigo: 'K90',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'DOENÇA VASCULAR CEREBRAL',
    codigo: 'K91',
    id_grupo: 'AVC',
  },
  {
    nm: null,
    nome: 'DENGUE E OUTRAS DOENÇAS VIRAIS NE',
    codigo: 'A77',
    id_grupo: 'DENGUE',
  },
  {
    nm: null,
    nome: 'ANEMIA POR DEFICIÊNCIA FERRO',
    codigo: 'B80',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'ANEMIA PERNICIOSA/DEFICIÊNCIA DE FOLATOS',
    codigo: 'B81',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'OUTRAS ANEMIAS NE',
    codigo: 'B82',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DEFICIÊNCIA VITAMÍNICA/NUTRICIONAL',
    codigo: 'T91',
    id_grupo: 'DESNUTRICAO',
  },
  {
    nm: null,
    nome: 'DIABETES INSULINO-DEPENDENTE',
    codigo: 'T89',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES NÃO INSULINO-DEPENDENTE',
    codigo: 'T90',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DOENÇA PULMONAR OBSTRUTIVA CRÔNICA',
    codigo: 'R95',
    id_grupo: 'DPOC',
  },
  { nm: null, nome: 'SÍFILIS FEMININA', codigo: 'X70', id_grupo: 'DTS' },
  { nm: null, nome: 'GONORRÉIA FEMININA', codigo: 'X71', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'TRICOMONÍASE GENITAL FEMININA',
    codigo: 'X73',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'HERPES GENITAL FEMININO', codigo: 'X90', id_grupo: 'DTS' },
  {
    nm: null,
    nome: 'CONDILOMA ACUMINADO FEMININO',
    codigo: 'X91',
    id_grupo: 'DTS',
  },
  { nm: null, nome: 'INFECÇÃO POR CLAMÍDIA', codigo: 'X92', id_grupo: 'DTS' },
  { nm: null, nome: 'SÍFILIS MASCULINA', codigo: 'Y70', id_grupo: 'DTS' },
  { nm: null, nome: 'GONORRÉIA MASCULINA', codigo: 'Y71', id_grupo: 'DTS' },
  { nm: null, nome: 'HERPES GENITAL', codigo: 'Y72', id_grupo: 'DTS' },
  { nm: null, nome: 'CONDILOMA ACUMINADO', codigo: 'Y76', id_grupo: 'DTS' },
  { nm: null, nome: 'GRAVIDEZ', codigo: 'W78', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'GRAVIDEZ NÃO DESEJADA',
    codigo: 'W79',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TOXEMIA GRAVÍDICA/ DHEG',
    codigo: 'W81',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ DE ALTO RISCO',
    codigo: 'W84',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES GESTACIONAL',
    codigo: 'W85',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HANSENÍASE E OUTRAS DOENÇAS INFECCIOSAS NE',
    codigo: 'A78',
    id_grupo: 'HANSENIASE',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SEM COMPLICAÇÕES',
    codigo: 'K86',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO COM COMPLICAÇÕES',
    codigo: 'K87',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'INFARTO OU ENFARTE AGUDO MIOCÁRDIO',
    codigo: 'K75',
    id_grupo: 'INFARTO',
  },
  {
    nm: null,
    nome: 'FIBRILAÇÃO/FLUTTER AURICULAR/ ATRIAL',
    codigo: 'K78',
    id_grupo: 'INFARTO',
  },
  { nm: null, nome: 'OBESIDADE', codigo: 'T82', id_grupo: 'OBESIDADE' },
  {
    nm: null,
    nome: 'ESCLARECIMENTO/DISCUSSÃO DO MOTIVO DA CONSULTA',
    codigo: '48',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTROS PROCEDIMENTOS PREVENTIVOS',
    codigo: '49',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS PSICOLÓGICOS, OUTROS',
    codigo: 'P29',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS PÓS-PARTO',
    codigo: 'W18',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS DA MAMA/LACTAÇÃO',
    codigo: 'W19',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SEPSIS/INFECÇÃO PUERPERAL',
    codigo: 'W70',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'PARTO SEM COMPLICAÇÕES DE NASCIDO VIVO',
    codigo: 'W90',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'PARTO SEM COMPLICAÇÕES DE NATIMORTO',
    codigo: 'W91',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'PARTO COM COMPLICAÇÕES DE NASCIDO VIVO',
    codigo: 'W92',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'PARTO COM COMPLICAÇÕES DE NATIMORTO',
    codigo: 'W93',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'MASTITE PUERPERAL', codigo: 'W94', id_grupo: 'PARTO' },
  {
    nm: null,
    nome: 'OUTROS PROBLEMAS DA MAMA DURANTE GRAVIDEZ/PUERPÉRIO',
    codigo: 'W95',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES DO PUERPÉRIO',
    codigo: 'W96',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: null, codigo: 'A57', id_grupo: 'REABILITACAO' },
  { nm: null, nome: 'PIELONEFRITE', codigo: 'U70', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'CISTITE/OUTRA INFECÇÃO URINÁRIA',
    codigo: 'U71',
    id_grupo: 'RINS',
  },
  { nm: null, nome: 'URETRITE', codigo: 'U72', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'NEOPLASIA MALIGNA DO RIM',
    codigo: 'U75',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA BENIGNA DO RIM',
    codigo: 'U76',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA MALIGNA DO APARELHO URINÁRIO, OUTRA',
    codigo: 'U77',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA BENIGNA DO APARELHO URINÁRIO',
    codigo: 'U78',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'NEOPLASIA DO APARELHO URINÁRIO NE',
    codigo: 'U79',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'LESÕES TRAUMÁTICAS DO APARELHO URINÁRIO',
    codigo: 'U80',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'MALFORMAÇÃO CONGÊNITA DO APARELHO URINÁRIO',
    codigo: 'U85',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'GLOMERULONEFRITE/ SÍNDROME NEFRÓTICA',
    codigo: 'U88',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'ALBUMINÚRIA/PROTEINÚRIA ORTOSTÁTICA',
    codigo: 'U90',
    id_grupo: 'RINS',
  },
  { nm: null, nome: 'CÁLCULO URINÁRIO', codigo: 'U95', id_grupo: 'RINS' },
  {
    nm: null,
    nome: 'ANÁLISE DE URINA ANORMAL NE',
    codigo: 'U98',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'OUTRAS DOENÇAS URINÁRIAS',
    codigo: 'U99',
    id_grupo: 'RINS',
  },
  {
    nm: null,
    nome: 'REAÇÃO AGUDA AO ESTRESSE',
    codigo: 'P02',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERTURBAÇÃO DO SONO',
    codigo: 'P06',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'GAGUEJAR/BALBUCIAR/TIQUES',
    codigo: 'P10',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PROBLEMAS DE ALIMENTAÇÃO DA CRIANÇA',
    codigo: 'P11',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'MOLHAR A CAMA/ENURESE',
    codigo: 'P12',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'ENCOPRESE/OUTROS PROBLEMAS DE INCONTINÊNCIA FECAL',
    codigo: 'P13',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS RELACIONADOS AO COMPORTAMENTO DA CRIANÇA',
    codigo: 'P22',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS RELACIONADOS AO COMPORTAMENTO DO ADOLESCENTE',
    codigo: 'P23',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DIFICULDADES ESPECÍFICAS DE APRENDIZAGEM',
    codigo: 'P24',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS PSICOLÓGICOS, OUTROS',
    codigo: 'P29',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'DEMÊNCIA', codigo: 'P70', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'OUTRAS PSICOSES ORGÂNICAS NE',
    codigo: 'P71',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'ESQUIZOFRENIA', codigo: 'P72', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'PSICOSE AFETIVA',
    codigo: 'P73',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'DISTÚRBIO ANSIOSO/ESTADO DE ANSIEDADE',
    codigo: 'P74',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'SOMATIZAÇÃO', codigo: 'P75', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'PERTURBAÇÕES DEPRESSIVAS',
    codigo: 'P76',
    id_grupo: 'SAUDE_MENTAL',
  },
  { nm: null, nome: 'NEURASTENIA', codigo: 'P78', id_grupo: 'SAUDE_MENTAL' },
  {
    nm: null,
    nome: 'FOBIA/PERTURBAÇÃO COMPULSIVA',
    codigo: 'P79',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERTURBAÇÕES DE PERSONALIDADE',
    codigo: 'P80',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'PERTURBAÇÃO HIPERCINÉTICA',
    codigo: 'P81',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'RETARDO/ ATRASO MENTAL',
    codigo: 'P85',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRAS PSICOSES NE',
    codigo: 'P98',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'OUTRAS PERTURBAÇÕES PSICOLÓGICAS',
    codigo: 'P99',
    id_grupo: 'SAUDE_MENTAL',
  },
  {
    nm: null,
    nome: 'MEDO DE VIH/ HIV/SIDA/ AIDS',
    codigo: 'B25',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDO DE ESTAR GRÁVIDA',
    codigo: 'W02',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTRACEPÇÃO PÓS-COITAL',
    codigo: 'W10',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTRACEPÇÃO ORAL',
    codigo: 'W11',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTRACEPÇÃO INTRA-UTERINA/ DISPOSITIVO INTRAUTERINO/ DIU',
    codigo: 'W12',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ESTERILIZAÇÃO',
    codigo: 'W13',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTRACEPÇÃO/OUTROS',
    codigo: 'W14',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE/SUBFERTILDADE',
    codigo: 'W15',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ NÃO DESEJADA',
    codigo: 'W79',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABORTO ESPONTÂNEO',
    codigo: 'W82',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DOR GENITAL',
    codigo: 'X01',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DORES MENSTRUAIS',
    codigo: 'X02',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DORES INTERMENSTRUAIS',
    codigo: 'X03',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'RELAÇÃO SEXUAL DOLOROSA NA MULHER',
    codigo: 'X04',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO ESCASSA/AUSENTE',
    codigo: 'X05',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA',
    codigo: 'X06',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO IRREGULAR/FREQUENTE',
    codigo: 'X07',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTERMENSTRUAL',
    codigo: 'X08',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS PRÉ-MENSTRUAIS',
    codigo: 'X09',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DESEJO DE ALTERAR A DATA MENSTRUAÇÃO',
    codigo: 'X10',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS DA MENOPAUSA/ CLIMATÉRIO',
    codigo: 'X11',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA PÓS-MENOPAUSA',
    codigo: 'X12',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA PÓS-COITAL',
    codigo: 'X13',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDO DE DOENÇA DE TRANSMISSÃO SEXUAL',
    codigo: 'X23',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDO DE DISFUNÇÃO SEXUAL',
    codigo: 'X24',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'LESÃO TRAUMÁTICA GENITAL FEMININA',
    codigo: 'X82',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SÍNDROME DA TENSÃO PRÉ-MENSTRUAL',
    codigo: 'X89',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PLANEJAMENTO FAMILIAR, OUTROS',
    codigo: 'Y14',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  { nm: null, nome: 'ABUSO DO TABACO', codigo: 'P17', id_grupo: 'TABAGISMO' },
  { nm: null, nome: 'TUBERCULOSE', codigo: 'A70', id_grupo: 'TUBERCULOSE' },
  {
    nm: null,
    nome: 'ABUSO CRÔNICO DE ÁLCOOL',
    codigo: 'P15',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'ABUSO AGUDO DE ÁLCOOL',
    codigo: 'P16',
    id_grupo: 'USUARIO_ALCOOL',
  },
  {
    nm: null,
    nome: 'ABUSO DE MEDICAÇÃO',
    codigo: 'P18',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
  {
    nm: null,
    nome: 'ABUSO DE DROGAS',
    codigo: 'P19',
    id_grupo: 'USUARIO_OUTRAS_DROGAS',
  },
]
